// extracted by mini-css-extract-plugin
module.exports = {"leftCell":"leftCell__2Vn2HodZ1cDX"};